import { isLocalSeoUser } from 'src/common/config/FunctionHelper';
import { SEOSpaceLocal } from 'src/common/config/TextMessage';

const isLocalSeo = isLocalSeoUser() || null;

export const localSeoTexts = {
  helmetText: 'SEOSpace | Local SEO Tools',
  localSeo: 'Local SEO',
  businessProfile: 'Business Profile',
  tutorialText: 'How to Optimize Your Google Business Profile',
  upgradeTitle: 'Business Profile Dashboard',
  upgradeDesc: 'Attract Customers Searching In Your Area',
  unlockDesc:
    '46% of Google searches are for something local. This tool helps you appear in those results - so more people find and choose your business.',
  selectThisProfile: 'Select This Profile',
  manageReviews: 'Manage Reviews',
  posting: 'Posting',
  googleBusinessProfilePosts: 'Google Business Profile Posts',
  googleBusinessProfilePostsDesc:
    'Manage your posts, create new ones and schedule them to be published',
  createNewPost: 'Create New Post',
  noPostFound: 'No Data Found',
  createPost: 'Create New Post',
  manageReviewsBreadCrumb: 'Manage Reviews',
  upgradePlan: 'Upgrade Plan',
  oneTimeAddOn: 'Local SEO Add-On',
  postingBreadCrumb: 'Google Business Profile Posts',
  saveModalFooterText: 'By saving, you confirm that your changes comply with ',
  googlePolicies: 'Google’s Business Profile guidelines',
  guidelinesForBusinessProfiles: 'guidelines for Business Profiles.',
  noPostdata:
    "You don't have any posts on this account yet. Create or schedule your first one right now!",
  localSeoTaskDesc:
    'Complete these prioritized tasks to improve your Google ranking. Each task includes step-by-step instructions. Some can be done directly in SEOSpace, others may require manual research or changes to your Business Profile.',
  tasksCompleted: 'tasks completed',
  localSEOTasks: 'Local SEO Tasks',
  markAsDone: 'Mark as Done',
  fixNow: 'Fix Now!',
  openGoogleMaps: 'Open Google Maps',
  viewMore: 'View your reviews',
  googleReviews: 'Google Reviews',
  businessPosts: 'Business Posts',
  connectGoogleBusinessProfile: 'Connect Google Business Profile',
  selectedProfile: 'Already Added',
  listingManager: 'Listing Manager',
  glmDesc:
    'Edit your Google Business Profile directly from SEOSpace and get guidance on what to improve. Use this sparingly. Frequent edits can hurt your rankings. Always follow ',
  localSeoTaskUpgradeTitle: 'Local SEO Tasks',
  localSeoTaskUpgradeDesc:
    'Work through high-impact tasks proven to increase your local search rankings and bring more nearby customers to your business.',
  localSeoTaskUpgradeMainDesc: 'Boost Your Local Visibility',
  localSeoPostingTitle: 'Google Business Profile Posts',
  localSeoPostingMainDesc: 'Keep Your Audience Engaged',
  localSeoPostingSubDesc:
    'Post updates directly to your Google Business Profile to highlight offers, share news, and attract more local traffic.',
  localSeoTaskHelmetText: 'SEOSpace | Local SEO Tasks',
  backLinkHelmetText: 'SEOSpace | Backlink Analysis',
  businessProfileHelmetText: 'SEOSpace | Business Profile Dashboard',
  listingManagerHelmetText: 'SEOSpace | Listing Manager',
  googleReviewsHelmetText: 'SEOSpace | Google Reviews',
  businessPostHelmetText: 'SEOSpace | Business Posts',
  rankTrackingFrequency: 'Rank Tracking Frequency',
  viewSEOTasks: 'View SEO Tasks',
  deleteProfile: 'Delete Profile from SEOSpace',
  actions: 'Actions',
  deleteProfileDescription:
    'Remove this profile and all its associated data from your SEOSpace account.',
  addonFooter: 'Unsure about Local SEO? ',
  clickLearnMore: 'Click here to learn more.',
  citationBuilder: 'Citation Builder',
  citationBuilderTutorial: 'Citation Builder Tutorial',
  listingUpgradeTitle: 'Listing Manager',
  reviewsUpgradeTitle: 'Google Reviews',
  embedGoogle: 'Embed Google Reviews to Squarespace',
  checkAICrawler: 'Check AI Crawler Settings',
  sqspSnackbarMessage:
    'Thanks for connecting! We’ve automatically selected the Google Business Profile that matches your website URL. You’re all set to move on.',
  manageGoogleReviews: 'Manage Google Reviews Widgets',
  createGoogleReviewsWidget: 'Create Google Reviews Widget',
  updateGoogleReviewsWidget: 'Update Google Reviews Widget',
  connectSqSp: 'Connect with Squarespace',
  auditAiSearch: 'See How AI Describes You',
  analyzeAiSources: 'See Sources Behind AI Search Results'
};

export const ConnectBusinessProfileModalTexts = {
  title: 'Connect SEOSpace To Your Google Business Profile',
  localSEO: `Connect ${
    isLocalSeo ? SEOSpaceLocal : 'Local SEO'
  } To Your Google Business Profile`,
  desc: 'Easily connect your Google Business Profile for centralized management within SEOSpace.',
  watchTutorial: 'Watch Tutorial (10:06)',
  btnText: 'Connect Your Google Business Profile',
  almostThere: 'Select A Business Profile',
  descTwo:
    'SEOSpace has detected the following Google Business Profiles - select one to continue.',
  localSeoDescTwo: `${
    isLocalSeo ? SEOSpaceLocal : 'Local SEO'
  } has detected the following Google Business Profiles - select one to continue.`,
  skip: 'Skip',
  redirectBtn: 'Redirecting in ',
  skipOnboarding: 'Skip Onboarding',
  chooseAnotherAccount: 'Choose Another Account'
};

export const ConfirmConnectionModalTexts = {
  title: 'Please Confirm Connection',
  desc: 'Your location and all linked reports will be updated with this connection. Please confirm that you want to continue.',
  continue: 'Continue',
  cancel: 'Cancel'
};

export const SkipOnboardingModalTexts = {
  title: 'Skip Onboarding',
  desc: `Skipping the onboarding will cancel the ${
    isLocalSeo ? SEOSpaceLocal : 'Local SEO'
  } setup flow. You will still need to disconnect the extension from Squarespace. Are you sure you want to skip?`,
  continue: 'Yes and Go to Squarespace',
  cancel: `Don't Skip`
};

export const DisconnectLocalModalTexts = {
  title: `${isLocalSeo ? SEOSpaceLocal : 'Local SEO'} Extension Disconnected`,
  desc: `We have detected that ${
    isLocalSeo ? SEOSpaceLocal : 'Local SEO'
  } Extension has been disconnected from Squarespace for this website. You can still finish setup here, but to sync with Squarespace, reconnect it from Squarespace Extensions.`,
  continue: 'Go to Squarespace',
  cancel: `Continue without extension`
};

export const CreateNewPostTexts = {
  createNewPost: 'Create New Post',
  postPreview: 'Post Preview',
  businessName: 'Business Name',
  businessNamePlaceHolder: 'Enter business name',
  postType: 'Post Type',
  update: 'Update',
  offer: 'Offer',
  postImage: 'Post Image (optional)',
  postImageDesc:
    'You are allowed to upload just a single image, with a maximum file size of 1 MB. However, Google allows the upload of multiple images and videos exclusively when using their own user interface for creating posts.',
  promotionTitle: 'Promotion Title',
  enterTitle: 'Enter title',
  startDate: 'Start Date',
  expirationDate: 'Expiration date',
  pickDate: 'Pick a date',
  otherInfo: 'Other Information (optional)',
  scheduleThisPost: 'Schedule This Post',
  saveAndPost: 'Post Now',
  details: 'Details',
  uploadImage: 'Upload Image',
  buttonType: 'Button Type',
  buttonLink: 'Button Link',
  buttonLinkPlaceHolder: 'Enter button link',
  addButton: 'Add a Button (optional)',
  promotionDesc: 'Promotion Description',
  couponCode: 'Coupon Code',
  redeemCouponLink: 'Redeem Coupon Link',
  redeemCouponLinkPlaceHolder: 'Enter redeem coupon link',
  termsAndConditions: 'Terms & Conditions',
  previewDesc:
    'Google sometimes updates formatting, so your post may appear slightly different when published.',
  businessNameError: 'Please enter business name',
  businessDescError: 'Please enter post description',
  buttonLinkError: 'Please enter business link',
  buttonLinkInValidError: 'Please enter valid link',
  promotionTitleError: 'Please enter promotion title',
  startDateError: 'Please enter start date',
  endDateError: 'Please enter expiration date',
  deletePost: 'Delete Post',
  delete: 'Proceed',
  cancel: 'Cancel',
  deletePostDesc: 'Are you sure you want to delete this post?',
  updatePost: 'Update Post',
  profileMinError: 'Image must be at least 1MB in size.'
};

export const manageReviewsTexts = {
  yourReviews: 'Your Reviews',
  totalReviews: 'Total Reviews',
  answered: 'Answered',
  avgRating: 'Avg Rating',
  manageReviews: 'Manage Reviews',
  noReviewsFound: 'No reviews found',
  reply: 'Reply',
  view: 'View',
  viewReviewText: 'Review Details',
  replyModalTitle: 'Reply to Google Review',
  enterReply: 'Enter your reply',
  replyBtn: 'Reply',
  close: 'Close',
  replyFooterText:
    'This customer will be notified about your reply, and it will be publicly visible on your Business Profile'
};

export const googleListManagerTexts = {
  businessNameError: 'Please enter business name',
  phoneNumError: 'Please enter phone number',
  descError: 'Please enter business description',
  businessAddress: 'Please enter business address',
  primaryNumError: 'Please enter primary number',
  townError: 'Please enter town/city',
  postCode: 'Please enter postcode',
  secondLineError: 'Please enter second line',
  webSiteError: 'Please enter valid link'
};

export const mapRankTrackerStepTexts = {
  setUpRankTracking: 'Set Up Rank Tracking',
  setUpLocalSEOTracking: 'Set Up Your Local SEO Tracking',
  setUpMonitoring: 'Set Up Monitoring',
  titleStepOne: 'How Do You Want to Get Found Locally?',
  localSEOTitleStepOne: 'Tell us how customers find your business',
  titleStepOneDesc:
    'Set your local search area and choose keywords your customers might use. For example, “florist near me” or “plumber in Chicago.” You can change this later.',
  localSEOtitleStepOneDesc:
    'Choose your local area and add keywords people might search to find you — like “florist near me” or “plumber in Chicago.” You can update this anytime.',
  nextStep: 'Continue',
  selectMonitoringFrequency: 'Select Monitoring Frequency',
  frequency:
    'Get automatic updates on whether you need to step in to improve your rankings.',
  frequencyText: 'Frequency',
  titleStepOneAddressDesc:
    'Add your business address to set your local search area. This helps us find nearby keywords your customers are likely to use, like “florist near me.”',
  additionalFields: 'Business Details'
};

export const yourLocalRankingTexts = {
  yourLocalRanking: 'Your Local Ranking',
  yourLocalRankingTooltip:
    'Shows how a business ranks on Google Maps in the selected area. The map displays numbered circles—if a circle shows “3”, it means the business appears 3rd at that location for the keyword you entered (e.g. “wedding photographer”). The center of the map is the business’s location, and the circles show how it ranks in nearby spots. This helps you understand how visible the business is locally. For deeper insights and to compare against competitors, visit the '
};

export const localSeoToolTipTexts = {
  selectRadius:
    'Choose how far around the selected business you want us to check its ranking on Google Maps. For example, a 5-mile radius means we check how often it shows up within 5 miles of that spot.'
};

export const MAX_KEYWORDS = 5;

export const localSeoTasks = {
  tip: 'Tip',
  tipDesc:
    'Many business owners fear asking for reviews after receiving a bad one. The best way to handle a negative review is to actively collect more positive ones — bury it with genuine 5-star feedback. Keep the momentum going. The more reviews you collect, the stronger your SEO and reputation will become.'
};

export const GMBTutorialLinks = {
  localSeoTutorial: 'https://www.youtube.com/watch?v=1IwejKrqUtc', // 1st video
  mapRankTutorial: 'https://www.youtube.com/watch?v=vMFBSJG9ON8', //2nd video
  optimiseBusinessCategory: 'https://www.youtube.com/watch?v=2gttxC8j9lY', // 3rd video
  embedGoogleMapLink: 'https://www.youtube.com/watch?v=nlt1AaDqLYQ', //4th video
  completeLocalKeyword: 'https://www.youtube.com/watch?v=-CFM5v_p6_g', // 5th video
  ensureNAPlink: 'https://www.youtube.com/watch?v=4sR3Uxi1GTA', // 6th video
  lookForListicle: 'https://www.youtube.com/watch?v=3p1KGqwLjfg', // 7th video
  reviewGBPLink: 'https://www.youtube.com/watch?v=N-3NMh7Z_D0', //8th video
  nameSpamming: 'https://www.youtube.com/watch?v=D1QDlMp5wmo', // 9th video
  googleGuidelinesLink:
    'https://support.google.com/business/topic/4596687?hl=en-GB&ref_topic=6377335',
  replyToGoogleReviews:
    'https://youtu.be/1IwejKrqUtc?t=384&si=NBOkMChSXlEBON8p',
  askForReviews:
    'https://support.google.com/business/answer/3474122?hl=en-GB&visit_id=638868858726182872-2917380889&p=search_more_reviews&rd=1#best_practice',
  setItUpNow:
    'https://intercom.help/seospace-help-centre/en/articles/11685023-how-to-create-and-verify-your-google-business-profile',
  collectMoreReviews: 'https://youtu.be/1IwejKrqUtc?t=384&si=j96NaK4UjU2YKb0I',
  mapClickHereUrl:
    'https://intercom.help/seospace-help-centre/en/articles/11728700-how-to-find-your-google-maps-url-for-the-local-search-grid'
};

export const timeFormats = [
  'GMT -12',
  'GMT -11',
  'GMT -10',
  'GMT -9',
  'GMT -8',
  'GMT -7',
  'GMT -6',
  'GMT -5',
  'GMT -4',
  'GMT -3:30',
  'GMT -3',
  'GMT -2',
  'GMT -1',
  'GMT 0',
  'GMT +1',
  'GMT +2',
  'GMT +3',
  'GMT +3:30',
  'GMT +4',
  'GMT +4:30',
  'GMT +5',
  'GMT +5:30',
  'GMT +6',
  'GMT +6:30',
  'GMT +7',
  'GMT +8',
  'GMT +9',
  'GMT +9:30',
  'GMT +10',
  'GMT +10:30',
  'GMT +11',
  'GMT +12'
];
